import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState('users', {
      usersLoading: 'isFindPending',
    }),

    ...mapGetters('users', {
      userInStore: 'list',
      getUser: 'get',
      findUsers: 'find',
    }),

    users() {
      return this.findUsers({
        query: {
          isDeleted: {
            $ne: true,
          },
        },
      }).data;
      // return this.userInStore.map(user => {
      //   user.displayName = `${user.FirstName} ${user.LastName}`;
      //   return user;
      // });
    }
  },

  methods: {
    ...mapActions('users', {
      fetchUsers: 'find',
      removeUser: 'remove'
    }),

    getUserEmail(id) {
      return _.get(this.getUser(id), 'email', '');
    },

    getUserColor(id) {
      return _.get(this.getUser(id), 'color', '');
    },
  }
};
